import { DrawingToolHelpers } from "../../../helpers/drawing-tool-helpers";
import { IComponent } from "../../component.interface";
import { IDrawingTool } from "../drawing-tool.interface";
import { DrawingToolsManager } from "../drawing-tools.manager";

export class MeasureComponent implements IComponent, IDrawingTool {
    public id = '';

    public annotation: any = null;
    private drawingToolManager: DrawingToolsManager;

    constructor(drawingToolManager: DrawingToolsManager, id: string) {
        this.drawingToolManager = drawingToolManager;
        this.id = id;
    }

    public static syncCreate(drawingToolManager: DrawingToolsManager, annotationOptions: any): MeasureComponent {
        const chart = drawingToolManager.base.tiChartSeries.highStockChart;
        
        annotationOptions.typeOptions.point.x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.point.actualXValue,
            annotationOptions.typeOptions.point.actualStartTimeT,
            drawingToolManager);

        const addedNewAnnotation: any = chart.addAnnotation(annotationOptions);

        drawingToolManager.updateAnnotationStyles(addedNewAnnotation, annotationOptions, false);
        const component = new MeasureComponent(drawingToolManager, annotationOptions.id);
        component.annotation = addedNewAnnotation;
        setTimeout(() => {
            try {
                component.annotation.update({
                    crop: true,
                    typeOptions: annotationOptions.typeOptions,
                    labelOptions: {
                        style: {
                            color: annotationOptions.labelOptions.style.color,
                            fontSize: annotationOptions.labelOptions.style.fontSize
                        }
                    },
                    shapeOptions: {
                        fill: annotationOptions.shapeOptions.fill,
                        stroke: annotationOptions.shapeOptions.stroke,
                    },
                });
            } catch {}
        }, 300);
        
        return component;
    }

    public static create(drawingToolManager: DrawingToolsManager, event: any): MeasureComponent {
        const component = new MeasureComponent(drawingToolManager, event.options.id);
        component.annotation = event;
        return component;
    }

    public syncUpdate(annotationOptions: any) {

    }

    public getMetaData(): any {
        const firstPoint = this.annotation.options.typeOptions.point;
        const actualFirstPosition = DrawingToolHelpers.getActualStartTimePosition(firstPoint, this.drawingToolManager);

        return {
            id: this.id,
            langKey: "measure",
            type: 'measure', // options type
            typeOptions: {
                xAxis: this.annotation.options.typeOptions.xAxis,
                yAxis: this.annotation.options.typeOptions.yAxis,
                background: this.annotation.options.typeOptions.background,
                crosshairX: this.annotation.options.typeOptions.crosshairX,
                crosshairY: this.annotation.options.typeOptions.crosshairY,
                point: {
                    x: this.annotation.options.typeOptions.point.x,
                    
                    actualStartTimeT: actualFirstPosition?.actualStartTimeT,
                    actualXValue: actualFirstPosition?.actualXValue,
                    
                    y: this.annotation.options.typeOptions.point.y,
                },
                selectType: this.annotation.options.typeOptions.selectType
            },
            labelOptions: {
                style: {
                    color: this.annotation.options.labelOptions.style.color,
                    fontSize: this.annotation.options.labelOptions.style.fontSize
                }
            },
            shapeOptions: {
                fill: this.annotation.options.shapeOptions.fill,
                stroke: this.annotation.options.shapeOptions.stroke,
            },
        };
    }
}